import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { BaseEntityResolver } from './resolver.helper';
import { getTaxTypeFetched } from '../State/selectors/tax-type.selectors';
import { TaxTypeActions } from '../State/actions/tax-type.actions';

@Injectable({
    providedIn: 'root',
})
export class TaxTypeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getTaxTypeFetched, TaxTypeActions.loadRequest({}), store);
    }
}
